import { captureException, SeverityLevel } from '@sentry/react'
import { merge } from 'lodash-es'
import { prettifyError, ZodError } from 'zod'

import { appConfig } from '@/app-config/appConfig'

import { isProductionEnvironment } from './isProductionEnvironment'

export const shouldLogCapturedEvents = !isProductionEnvironment()

function severityToConsoleLevel(severity?: SeverityLevel) {
	if (severity === 'error' || severity === 'fatal') {
		return 'error'
	} else if (severity === 'warning') {
		return 'warn'
	} else if (severity === 'info') {
		return 'info'
	} else {
		return 'log'
	}
}

export const captureAndLogError: typeof captureException = (error, captureContext) => {
	const zodErrorPretty = error instanceof ZodError ? prettifyError(error) : undefined

	if (shouldLogCapturedEvents) {
		const level = severityToConsoleLevel(
			(captureContext && 'level' in captureContext && captureContext.level) || 'error',
		)
		console[level](zodErrorPretty ?? error, captureContext) // eslint-disable-line no-console
	}

	if (appConfig.SENTRY_ENABLED) {
		const context = zodErrorPretty
			? merge(captureContext, { extra: { schema_errors: zodErrorPretty.substring(0, 1024) } })
			: captureContext

		return captureException(error, context)
	}

	return Date.now().toString()
}
